/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteMetaData } from '../../models/delivery-note-meta-data';
import { KeyType } from '../../models/key-type';

export interface PutDeliveryNoteMetaData$Params {
  organizationKey: KeyType;
  deliveryNoteKey: KeyType;
      body: DeliveryNoteMetaData
}

export function putDeliveryNoteMetaData(http: HttpClient, rootUrl: string, params: PutDeliveryNoteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putDeliveryNoteMetaData.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putDeliveryNoteMetaData.PATH = '/organizations/{organizationKey}/delivery-notes/{deliveryNoteKey}/metadata';
